import UserDetail from '../components/Users/User';

const UserScreen = () => <UserDetail />;

export default UserScreen;
